import { render, staticRenderFns } from "./Inboundlist-bottom.vue?vue&type=template&id=523e9cbc&scoped=true&"
import script from "./Inboundlist-bottom.vue?vue&type=script&lang=js&"
export * from "./Inboundlist-bottom.vue?vue&type=script&lang=js&"
import style0 from "./Inboundlist-bottom.vue?vue&type=style&index=0&id=523e9cbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e9cbc",
  null
  
)

export default component.exports